import { FC, ReactNode } from "react";
import { ChevronDown } from "lucide-react";

interface HelpSupportCardProps {
  icon: ReactNode;
  iconVariant: "bug" | "feature" | "support";
  title: string;
  subtitle: string;
  isOpen: boolean;
  onToggle: () => void;
  children: ReactNode;
}

const HelpSupportCard: FC<HelpSupportCardProps> = ({
  icon,
  iconVariant,
  title,
  subtitle,
  isOpen,
  onToggle,
  children,
}) => (
  <section className="help-support-card">
    <button
      type="button"
      className="help-support-card__header"
      aria-expanded={isOpen}
      onClick={onToggle}
    >
      <span
        className={`help-support-card__icon help-support-card__icon--${iconVariant}`}
        aria-hidden
      >
        {icon}
      </span>
      <span className="help-support-card__heading">
        <span className="help-support-card__title">{title}</span>
        <span className="help-support-card__subtitle">{subtitle}</span>
      </span>
      <ChevronDown
        size={18}
        className={`help-support-card__chevron ${
          isOpen ? "help-support-card__chevron--open" : ""
        }`}
        aria-hidden
      />
    </button>

    {isOpen ? <div className="help-support-card__body">{children}</div> : null}
  </section>
);

export default HelpSupportCard;
